{
  "add": "Add",
  "create": "Create",
  "confirm": "Confirm",
  "creating": "Creating...",
  "proceed": "Proceed",
  "update": "Update",
  "edit": "Edit",
  "cancel": "Cancel",
  "close": "Close",
  "delete": "Delete",
  "process": "Process",
  "save": "Save",
  "later": "Later",
  "saveForLater": "Save for later",
  "next": "Next",
  "continue": "Continue",
  "activate": "Activate",
  "deactivate": "Deactivate",
  "draft": "Draft",
  "error": "Error",
  "search": "Search",
  "download": "Download",
  "warning": "Warning",
  "notRequired": "Not Required",
  "notEditable": "Not Editable",
  "unknownOrganization": "Unknown",
  "unknownRole": "Unknown role",
  "goalValue": "of {{goalValue}}",
  "overfundedBy": "Overfunded by {{percentage}}%",
  "sign": "Sign",
  "upload": "Upload",
  "reupload": "Reupload",
  "retry": "Retry",
  "import": "Import",
  "validationError": {
    "unique": "This record already exists. Please, select a different",
    "sessionTimeout": "Your session has expired. Please log back in.",
    "tokenRefreshFailed": "Your session expired. Please login again.",
    "duplicateRecord": "A record with these values already exists. Please use unique values."
  },
  "backendIssuedError": {
    "organizationUserNotFound": "We're still setting things up or this profile isn't registered yet. Please try again later."
  },
  "enable": "Enable",
  "enabled": "Enabled",
  "disable": "Disable",
  "disabled": "Disabled",
  "inheritedFlag": "Inherited",
  "inheritedTooltip": "This {{model}} has been inherited from the {{organization}} organization. Please reach out to {{organization}} organization to change this.",
  "yes": "Yes",
  "no": "No",
  "inherited": "Inherited",
  "any": "Any",
  "true": "True",
  "false": "False",
  "requiedField": "Required Field!",
  "required": "Required",
  "nameRequired": "Name required",
  "requireAffiliate": "Account type: {{accountType}} requires at least one {{affiliateType}}",
  "noPermission": "You do not have a permission to access this space",
  "missingPermissionIs": "the permission missing is",
  "back": "Back",
  "home": "Home",
  "yesExit": "Yes, Exit",
  "wizardInterruptionMsg": "Closing this window will delete your progress. Are you sure you want to exit?",
  "wizardTitle": "Exit '{{wizardTitle}}'?",
  "somethingBelongingToSomeone": "{{whose}}'s {{what}}",
  "household": "household",
  "powerOfAttorney": "Power of Attorney",
  "okGotIt": "Ok, Got it",
  "copyToClientNotes": "Copy to client's notes",
  "organization": "Organization",
  "inheritedDashWhat": "Inherited - {{what}}",
  "someErrorHasOccurred": "Some error has occurred!",
  "somethingWentWrong": "Something went wrong",
  "completed": "Completed",
  "relationship": "Relationship",
  "phoneNumber": "Phone Number",
  "email": "Email",
  "status": "Status",
  "state": "State",
  "entity": "Entity",
  "markAllAsRead": "Mark all as read",
  "noNotifications": "You have no notifications",
  "notificationsMenu": {
    "title": "Notifications",
    "ALL": "All Activity",
    "UNREAD": "Unread",
    "today": "Today"
  },
  "done": "Done",
  "clearAll": "Clear all",
  "addNewColumn": "Add New Column",
  "commaSeparated": "Comma Separated",
  "securityDetails": "Security Details",
  "name": "Name",
  "type": "Type",
  "cash": "Cash",
  "actions": "Actions",
  "archive": "Archive",
  "only": "only",
  "notClassified": "Not classified",
  "publish": "Publish",
  "unpublish": "Unpublish",
  "viewAll": "View All",
  "published": "Published",
  "inactive": "Inactive",
  "saved": "Saved",
  "successfullySaved": "Successfully saved",
  "filter": "Filter",
  "perPage": "per page",
  "perPageWithSize": "{{size}} per page",
  "rowsPerPage": "Rows per page:",
  "copiedToClipboard": "Copied to clipboard",
  "country": "Country",
  "fixedColumn": "Fixed Column",
  "tableDefinition": "Tables are configurable to display a number of data points. On smaller screens, the first column remains fixed allowing the others to be horizontally scrolled into view. The simplified mobile version shows only essential information, allowing access to the full dataset by tapping the row.",
  "browserTable": "Browser Table",
  "mobileTable": "Mobile Table",
  "on": "on",
  "print": "Print",
  "continued": "continued",
  "auditLog": "Audit Log",
  "start": "Start",
  "end": "End",
  "objectId": "Object ID",
  "invalidObjectId": "Invalid Object ID",
  "validObjectId": "Valid Object ID",
  "loading": "Loading...",
  "submit": "Submit",
  "copyID": "Copy ID",
  "description": "Description",
  "inactiveModal": {
    "headingText": "Are you still there?",
    "prefixButton": "Keep me logged in",
    "suffixButton": "Log out now",
    "bodyText1": "Due to inactivity, your session will expire in",
    "bodyText2": "seconds."
  },
  "SessionTimeoutLayoutModal": {
    "loginButton": "Log in",
    "headingText": "You were logged out",
    "bodyText": "Due to inactivity, your session has expired. If you want to keep using the App, please log in again."
  },
  "withdraw": "Withdraw",
  "deposit": "Deposit",
  "amountUnavailable": " Amount unavailable",
  "errorStateSubText": "There is an issue with the system. Please try again later.",
  "errroStateTitle": "Unable to load data",
  "errroStateAccountTitle": "Unable to load accounts",
  "errroStateGoalTitle": "Unable to load goals",
  "paginationSummary": "{{start}}-{{end}} of {{total}}",
  "dataTablePaginationSummary": "Rows: {{start}}–{{end}} of {{total}}",
  "genderOptions": {
    "MALE": "Male",
    "FEMALE": "Female",
    "OTHER": "Another Gender"
  },
  "invalidAllocations": "The total allocation for each affiliation type must be exactly 100%.",
  "maxAttemptsExceeded": "You have reached the maximum number of attempts. Please contact support.",
  "failedVerificationAttemp": "Some verification answers are incorrect. You have {{attempt}} attempt(s) remaining",
  "profileDetailsUpdated": "Profile details have been updated.",
  "objectUpdated": "{{object}} updated successfully.",
  "objectClosed": "{{object}} has been closed.",
  "objectArchived": "{{object}} has been archived.",
  "unsafeUrl": "Invalid or unsafe URL. The link could not be opened for security reasons.",
  "organizationSwitchNotSaved": "Your change wasn't saved. You may not have permission to change this setting.",
  "relationshipInformation": {
    "selectSpouse": "Select spouse",
    "selectTrustedContact": "Select trusted contact person",
    "clearSelectedSpouse": "Clear selected spouse",
    "clearSelectedTrustedContact": "Clear selected TCP",
    "relationUpdateError": "Something went wrong updating the relationship. Please try again."
  }
}
